
Ext.define('SA.view.TableDragActivityFactory', {
    constructor({topHeader, controller, observable, autoScrollAmountPerAnimationFrame}) {
        this.topHeader = topHeader;
        this.controller = controller;
        this.observable = observable;
        this.autoScrollAmountPerAnimationFrame = autoScrollAmountPerAnimationFrame;
    },

    createActivityForTopHeaderMouseDown(mouseDownEv) {
        var topHeader = this.topHeader,
            controller = this.controller,
            observable = this.observable,
            autoScrollAmountPerAnimationFrame = this.autoScrollAmountPerAnimationFrame,
            td = mouseDownEv.target.closest('td'),
            dragColId = td.dataset.colId,
            targetContentEl = td.children[0],
            mouseDownOffset = SA.view.Position.fromMouseEvent(mouseDownEv).subtract(SA.view.Position.forEl(targetContentEl));

        document.addEventListener('mouseup', onNoDragMouseUp, {once: true});
        document.addEventListener('mousemove', onFirstMouseMove, {once: true});

        function onNoDragMouseUp() {
            document.removeEventListener('mousemove', onFirstMouseMove, {once: true});
        }

        function onFirstMouseMove(firstMouseMoveEv) {
            var mouseUp = false,
                originalTrackIds = controller.getTrackIds(),
                animationFrameGenerator = SA.view.AnimationFrameGenerator.getGenerator(),
                nextFrame = () => animationFrameGenerator.next(),
                clone = SA.view.TableDragCellCloneFactory.createClone({el: targetContentEl, mouseDownOffset}),
                testIntersectsTopHeader = () => clone.getRegion().intersects(topHeader.getRegion()),
                didIntersectTopHeader = false,
                doesIntersectTopHeader = testIntersectsTopHeader();

            document.removeEventListener('mouseup', onNoDragMouseUp, {once: true});

            document.addEventListener('mouseup', onPostDragMouseUp, {once: true});
            document.addEventListener('mousemove', onMouseMove);

            clone.syncWithMouseEv(firstMouseMoveEv);
            controller.setDragColId(dragColId);
            controller.render();

            nextFrame().then(async () => {
                var topHeaderRegion = topHeader.getRegion();

                while (!mouseUp) {
                    let cloneRegion = clone.getRegion();

                    if (cloneRegion.intersects(topHeaderRegion)) {
                        let topHeaderContentEls = topHeader.getCells().map(cell => cell.children[0]),
                            cellIntersection = getTopHeaderCellIntersection({cloneRegion, topHeaderContentEls}),
                            {colId: cellColId, cellSide} = cellIntersection;

                        if (cellColId !== dragColId) {
                            if (cellSide === 'LEFT') {
                                controller.moveColIdBefore(dragColId, cellColId);
                                controller.render();
                            }
                            else {
                                controller.moveColIdAfter(dragColId, cellColId);
                                controller.render();
                            }
                        }

                        if (cloneRegion.getLeft() < topHeaderRegion.getLeft()) {
                            controller.scrollLeftBy(autoScrollAmountPerAnimationFrame);
                            controller.render();
                        }
                        else if (cloneRegion.getRight() > topHeaderRegion.getRight()) {
                            controller.scrollRightBy(autoScrollAmountPerAnimationFrame);
                            controller.render();
                        }
                    }

                    await nextFrame();
                }
            });

            function onPostDragMouseUp() {
                mouseUp = true;
                clone.destroy();
                document.removeEventListener('mousemove', onMouseMove);
                controller.clearDragColId();
                controller.render();
                observable.fireEvent('dragend');
            }

            function onMouseMove(ev) {
                clone.syncWithMouseEv(ev);

                didIntersectTopHeader = doesIntersectTopHeader;
                doesIntersectTopHeader = testIntersectsTopHeader();

                if (didIntersectTopHeader && !doesIntersectTopHeader) {
                    controller.setTrackIds(originalTrackIds);
                    controller.render();
                }
            }
        }

        function getTopHeaderCellIntersection({cloneRegion, topHeaderContentEls}) {
            var topHeaderCellItems = topHeaderContentEls
                    .map(el => {
                        var colId = el.parentElement.dataset.colId,
                            cellRegion = SA.view.Region.forEl(el).growBy(1), 
                            overlap = cloneRegion.intersect(cellRegion).getWidth(),
                            isLeftSide = cloneRegion.getHorizontalCenter() < cellRegion.getHorizontalCenter();

                        return {colId, overlap, isLeftSide};
                    }),
                maxOverlap = Math.max(...topHeaderCellItems.map(({overlap}) => overlap)),
                {colId, isLeftSide} = topHeaderCellItems.find(({overlap}) => overlap === maxOverlap);

            return isLeftSide ? {colId, cellSide: 'LEFT'} : {colId, cellSide: 'RIGHT'};
        }
    }
});